/*jshint esversion: 6 */
// import Vue from 'vue';
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

// import router from '@/router/index';

const initialState = () => ({
  error: '',
  loading: false,
  log_list: [],
  log_list_filter: {
    filter: false,
    actions: [],
  },
  log_list_filter_new: localStorage.getItem('LOGLIST_filter') || false,
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getLogListFilter: (state) => {
    return state.log_list_filter;
  },
  getWorkPackageLogList: (state) => {
    if (state.log_list_filter.filter) {
      return state.log_list.filter(entry => state.log_list_filter.actions.includes(entry.action));
    } else {
      return state.log_list;
    }
  },
  getWorkPackageComments: (state) => {
    return state.log_list.filter(entry => entry.target === 'comment');
  },
  getWorkPackageLogListNew: (state) => {
    // console.table(state.log_list);
    let list = [];
    if (state.log_list_filter_new) {
      list = JSON.parse(JSON.stringify(state.log_list.filter(entry => entry.action.includes(state.log_list_filter_new))));
    } else {
      list = JSON.parse(JSON.stringify(state.log_list));
    }
    return list.sort((a,b) => {
      if (a.created > b.created) {
        return -1;
      }
      if (a.created < b.created) {
        return 1;
      }
      // a muss gleich b sein
      return 0;
    });
  },
  isLoading: ( state ) => state.loading
};
// Actions
const actions = {
  requestWorkPackageLogList({commit}, payload){
    return new Promise((resolve, reject) => {
      let url;
      // console.log(payload);
      if (payload.backlog) {
        url = 'projects/' +
        payload.project_id +
        '/wbgroups/' +
        payload.wbgroup_id +
        '/wblines/' +
        payload.wbline_id +
        '/wbworkpackages/' +
        payload.workpackage_id +
        '/logentries';
      } else {
        url = 'projects/' +
        payload.project_id +
        '/trains/' +
        payload.train_id +
        '/taktareas/' +
        payload.taktarea_id +
        '/twaggons/' +
        payload.twaggon_id +
        '/tworkpackages/' +
        payload.workpackage_id +
        '/logentries';
      }
      axios({
        url: url,
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_log_list', {log_list: resp.data.data});
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject();
      });
    });
  },
  setLogListFilter({commit}, payload) {
    commit('set_log_list_filter', payload);
  },
  setLogListFilterNew({commit}, payload) {
    localStorage.setItem('LOGLIST_filter', payload);
    commit('set_log_list_filter_new', payload);
  },
  createLogListComment({commit, rootState}, payload){
    let url;
    if (payload.backlog) {
      url = 'projects/' +
      payload.project_id +
      '/wbgroups/' +
      payload.wbgroup_id +
      '/wblines/' +
      payload.wbline_id +
      '/wbworkpackages/' +
      payload.workpackage_id +
      '/logentries';
    } else {
      url = 'projects/' +
      payload.project_id +
      '/trains/' +
      payload.train_id +
      '/taktareas/' +
      payload.taktarea_id +
      '/twaggons/' +
      payload.twaggon_id +
      '/tworkpackages/' +
      payload.workpackage_id +
      '/logentries';
    }
    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'POST',
        data: payload.data
      })
      .then(resp => {
        commit('log_list_add_comment', resp.data.data);
        if (!payload.backlog) {
          commit('Project/step_card_log_list_add_comment', {
            rootState,
            payload: {
              project_id: payload.project_id,
              twork_package_id: payload.twork_package_id,
              comment: resp.data.data,
            }
          }, {root: true});
        }
        resolve();
      })
      .catch(err => {
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        commit('set_error', extractErrorDetails(err));
        reject();
      });
    });
  },
  updateProjectAddress({commit, state}, payload){
    axios({
      url: 'projects/' + payload.project_id + '/address',
      method: 'PUT',
      data: state.projects[payload.project_id].address
    })
    .then(() => {
      commit('View/set_project_location_edit', false, { root: true });
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  updateLoglistEntry({ commit }, payload){
    let url;
    if (payload.backlog) {
      url = 'projects/' +
      payload.project_id +
      '/wbgroups/' +
      payload.wbgroup_id +
      '/wblines/' +
      payload.wbline_id +
      '/wbworkpackages/' +
      payload.workpackage_id +
      '/logentries/' + payload.entry_id;
    } else {
      url = 'projects/' +
      payload.project_id +
      '/trains/' +
      payload.train_id +
      '/taktareas/' +
      payload.taktarea_id +
      '/twaggons/' +
      payload.twaggon_id +
      '/tworkpackages/' +
      payload.workpackage_id +
      '/logentries/' + payload.entry_id;
    }
    axios({
        url: url,
        method: 'PUT',
        data: payload.update
      })
      .then(() => {
        commit('update_log_entry',
          payload
        );
        })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
      });
  }
};
// Mutations
const mutations = {
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_log_list(state, payload){
    state.log_list = [...payload.log_list];
  },
  set_log_list_filter(state, payload) {
    if (payload.setting === 'actions') {
      let index = state.log_list_filter.actions.findIndex(target => target === payload.value);
      if (index === -1) {
        state.log_list_filter.filter = true;
        state.log_list_filter.actions.push(payload.value);
        if (payload.value === 'added') {
          state.log_list_filter.actions.push('created');
        }
        else if (payload.value === 'removed') {
          state.log_list_filter.actions.push('deleted');
        }
      } else {
        state.log_list_filter.actions.splice(index, 1);
        if (payload.value === 'added') {
          state.log_list_filter.actions.splice(state.log_list_filter.actions.indexOf('created'), 1);
        }
        else if (payload.value === 'removed') {
          state.log_list_filter.actions.splice(state.log_list_filter.actions.indexOf('deleted'), 1);
        }
        if (state.log_list_filter.actions.length === 0) {
            state.log_list_filter.filter = false;
        }
      }
    } else {
      state.log_list_filter.filter = !state.log_list_filter.filter;
    }
  },
  set_log_list_filter_new(state, payload) {
    state.log_list_filter_new = payload;
  },
  set_error(state, error){
    state.error = error;
  },
  log_list_add_comment(state, comment){
    state.log_list = [
      ...state.log_list,
      comment
    ];
  },
  update_log_entry(state, payload){
    for (var i = 0; i < Object.keys(payload.update).length; i++) {
      state.log_list.find(entry => entry.id === payload.entry_id)[Object.keys(payload.update)[i]] = Object.values(payload.update)[i];
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
